import ContactBar from "./ContactBar";

const WhyOva = () => {

    return (
        <>
        <div id="tab-pourquoi" className="section">
            <div className="section-title">Pourquoi choisir OVA Consulting</div>
            <div className="section-sub">
                Ce qui fait la différence dans nos formations
            </div>
            <div className="why-grid">
                <div className="why-card">
                    <div className="why-icon">🎓</div>
                    <div className="why-title">Formateurs experts terrain</div>
                    <div className="why-desc">
                        Nos formateurs sont des praticiens en activité qui apportent des
                        situations réelles vécues en entreprise.
                    </div>
                </div>
                <div className="why-card">
                    <div className="why-icon">🔧</div>
                    <div className="why-title">100% pratique</div>
                    <div className="why-desc">
                        Chaque formation inclut des labs, exercices concrets et études de cas
                        directement applicables.
                    </div>
                </div>
                <div className="why-card">
                    <div className="why-icon">🌍</div>
                    <div className="why-title">Ancrage africain</div>
                    <div className="why-desc">
                        Nos cas d'usage sont adaptés aux réalités du marché camerounais et
                        d'Afrique centrale.
                    </div>
                </div>
                <div className="why-card">
                    <div className="why-icon">📋</div>
                    <div className="why-title">Attestation officielle</div>
                    <div className="why-desc">
                        Chaque participant reçoit une attestation OVA Consulting valorisable sur
                        le marché du travail.
                    </div>
                </div>
                <div className="why-card">
                    <div className="why-icon">🤝</div>
                    <div className="why-title">Accompagnement post-formation</div>
                    <div className="why-desc">
                        30 jours de support après la formation pour répondre aux questions de
                        mise en œuvre.
                    </div>
                </div>
                <div className="why-card">
                    <div className="why-icon">💰</div>
                    <div className="why-title">Tarifs adaptés</div>
                    <div className="why-desc">
                        Tarifs étudiés pour les entreprises camerounaises avec formules groupe
                        et packs annuels.
                    </div>
                </div>
            </div>
        </div>
        {/* <ContactBar /> */}
        </>
    );
}

export default WhyOva;